import React from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import { get, groupBy, map, size } from 'lodash'
import QueryManager from './Query'
import { withReloadable } from '../../hoc'

export const QUERY_GET_PICKING_FEED = gql`query getPickingFeed($size: Int, $sort: [SortInput], $filters: [FilterInput], $range: [RangeInput]) {
  pickingFeed(size: $size, sort: $sort, filters: $filters, range: $range) {
    count
    page
    results {
      ... on PickingProcess {
        foundRate
        bipicking
        ordersBipicking
        isPersonalShopperCustomer
        auditInfo {
            failedCount
            passedCount
            rules
        }
        pickingTime {
          init
          end
          stats {
            init
            end
            correlative
            field
          }
        }
        eanOrder
        startTime
        timePicking
        order {
          id
          shippingChange
          status
          createdAt
          idStore
          itemCount
          skuCount
          salesChannel {
            id
            name
          }
          pickerInfo {
            email
            name
            lastName
          }
          customer {
            email
            fullName
            document
            phone
            isVIP
            isCencoPrime
            address {
              addressLine
              neighborhood
            }
          }

                        logisticsInfo {
                            selectedSla
                            shippingEstimateDate
                            shippingEstimate
                            deliveryWindow {
                                price
                                startDateUtc
                                endDateUtc
                            }
                            shippingETA
                            shippingETAend
                        }
                    }
                    picker {
                        id
                        firstName
                        lastName
                    }
                    status {
                        label
                        code
                    }
                }
            }
        }
    }
`;

const GetPickingFeed = ({ children, ...props }) => {
    return (
        <QueryManager query={QUERY_GET_PICKING_FEED} {...props}>
            {({ data, loading, fetchMore, refetch, networkStatus }) => {
                const results = get(data, 'pickingFeed.results', []);

                return children({
                    data: map(results, ({ order, picker, ...assignInfo }) => ({
                        ...order,
                        assignInfo: { picker, ...assignInfo }
                    })),
                    count: get(data, 'pickingFeed.count'),
                    totals: size(results)
                        ? groupBy(results, 'status.code')
                        : {},
                    refetch,
                    loading,
                    fetchMore: ({ pageSize }) =>
                        fetchMore({
                            query: QUERY_GET_PICKING_FEED,
                            variables: {
                                cursor: get(data, 'pickingFeed.cursor'),
                                size: pageSize
                            },
                            updateQuery: () => null
                        }),
                    networkStatus
                });
            }}
        </QueryManager>
    );
};

GetPickingFeed.propTypes = {
    children: PropTypes.any
};

export default withReloadable(GetPickingFeed, ['ts']);